import React, { useEffect } from 'react';
import { string, func } from 'prop-types';
import styles from './css/Error.css';

export function Error({ message, clearPastWeatherFailure, testId }) {
  useEffect(() => () => clearPastWeatherFailure(), [clearPastWeatherFailure]);

  return (
    <div className={styles.container} data-test-id={testId}>
      <p className={styles.errorText}>{message}</p>
    </div>
  );
}

Error.propTypes = {
  clearPastWeatherFailure: func,
  message: string,
};
